module.exports = __webpack_public_path__ + "media/components/lesson3/common/statics/displayText-e3047dfa09e5dd74d4a0869cf65611a2.gif";